import { Swiper, SwiperSlide } from 'swiper/react';

import TVSeriesCarouselCard from 'pages/videoPage/shared/TVSeriesCarouselCard';
import VideoService from 'services/video/VideoService';
import { RouteName } from 'constant/routeNames';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';

function TrendingNearYouSideBar({ genre }: any) {
  const [cardDetails, setCardDetails] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  // This genre row never actually fetched anything - cardDetails stayed an
  // empty array forever, and the loading flag was tracked but never read,
  // so every row rendered its title with a permanently empty carousel and
  // no skeleton. The "see all by genre" page already does this correctly
  // (VideoService.getMoviesAndTVSeriesByGenre + MovieCardSkeleton) - reusing
  // that same call and skeleton here.
  useEffect(() => {
    const altName = genre?.alt_name;
    if (!altName) return;

    setLoading(true);
    VideoService.getMoviesAndTVSeriesByGenre(altName)
      .then((res: any) => {
        const combined = [...(res?.movies ?? []), ...(res?.['tv-series'] ?? [])];
        setCardDetails(combined);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [genre?.alt_name]);

  if (!loading && !cardDetails.length) return null;

  return (
    <div>
      <div className="flex justify-between w-[95%]">
        <h1 className="text-white md:text-xl text-md max-md:mx-3">
          {genre.name}
        </h1>
        <Link to={`${RouteName.VideoDiscoverRoute}/${genre.alt_name}`}>
          <p className="text-sm font-bold cursor-pointer red-text place-self-end">
            {''} See all
          </p>
        </Link>
      </div>

      <div className="">
        {loading ? (
          <div className="flex flex-row w-full gap-4 mt-2 overflow-hidden">
            {[1, 2, 3, 4, 5, 6, 7].map((item) => (
              <div
                key={item}
                className="min-w-[130px] lg:min-w-[210px] h-[280px] bg-[#1a1919] animate-pulse max-sm:mx-1"
              ></div>
            ))}
          </div>
        ) : (
          <Swiper
            slidesPerView={7}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              380: {
                slidesPerView: 2,
              },
              700: {
                slidesPerView: 3,
              },
              1000: {
                slidesPerView: 4,
              },
              1200: {
                slidesPerView: 5,
              },
              1400: {
                slidesPerView: 6,
              },
              1600: {
                slidesPerView: 7,
              },
            }}
            modules={[Pagination]}
            className="mySwiper"
          >
            {cardDetails.map((card: any, i: number) => (
              <SwiperSlide key={i}>
                <div className="mx-3 max-sm:mx-1">
                  <TVSeriesCarouselCard data={card} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </div>
  );
}

export default TrendingNearYouSideBar;
